<template>
  <NuxtLink
    :to="to"
    class="flex items-center rounded-lg transition-colors w-full"
    :class="[
      collapsed
        ? 'h-10 justify-center'
        : 'gap-3 px-3 py-2',
      isActive
        ? 'bg-blue-50 text-blue-700 font-semibold'
        : 'text-gray-500 hover:bg-gray-50 hover:text-gray-700 font-medium',
    ]"
    :title="collapsed ? label : undefined"
    @click="handleClick"
  >
    <span
      class="w-5 h-5 flex-shrink-0 transition-colors"
      :class="isActive ? 'text-blue-600' : 'text-gray-400'"
    >
      <!-- Stock Monitoring -->
      <svg v-if="icon === 'chart-bar'" fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
      </svg>
      <!-- Fulfillment Request -->
      <svg v-else-if="icon === 'clipboard-list'" fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"/>
      </svg>
      <!-- Calendar -->
      <svg v-else-if="icon === 'calendar'" fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
      </svg>
      <!-- Clock -->
      <svg v-else-if="icon === 'clock'" fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
      </svg>
      <!-- Factory -->
      <svg v-else-if="icon === 'factory'" fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
      </svg>
      <!-- Box -->
      <svg v-else-if="icon === 'box'" fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>
      </svg>
      <!-- Archive -->
      <svg v-else-if="icon === 'archive'" fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"/>
      </svg>
      <!-- Trending up -->
      <svg v-else-if="icon === 'trending-up'" fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941"/>
      </svg>
      <!-- ETL -->
      <svg v-else-if="icon === 'etl'" fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
      </svg>
      <!-- Tabel Data — grid tabel -->
      <svg v-else-if="icon === 'table'" fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M3 15h18M9 5v14M4 5h16a1 1 0 011 1v12a1 1 0 01-1 1H4a1 1 0 01-1-1V6a1 1 0 011-1z"/>
      </svg>
      <!-- Dashboard — kartu-kartu di grid -->
      <svg v-else-if="icon === 'layout'" fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a1 1 0 011-1h5a1 1 0 011 1v5a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM13 5a1 1 0 011-1h5a1 1 0 011 1v3a1 1 0 01-1 1h-5a1 1 0 01-1-1V5zM4 15a1 1 0 011-1h5a1 1 0 011 1v4a1 1 0 01-1 1H5a1 1 0 01-1-1v-4zM13 12a1 1 0 011-1h5a1 1 0 011 1v7a1 1 0 01-1 1h-5a1 1 0 01-1-1v-7z"/>
      </svg>
      <!-- Analisa — corong/filter agregasi -->
      <svg v-else-if="icon === 'analysis'" fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h18l-7 8v6l-4 2v-8L3 4z"/>
      </svg>
      <!-- Simulation — monitor/screen, matched dengan tombol Simulation di Production Planning -->
      <svg v-else-if="icon === 'simulation'" fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
      </svg>
      <!-- Warehouse — gudang dengan atap miring + pintu, representatif untuk Production Stock TGI -->
      <svg v-else-if="icon === 'warehouse'" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24" class="w-5 h-5">
        <path d="M22 8.35V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.35"/>
        <path d="M2 8.35l10-5.5 10 5.5"/>
        <path d="M6 22v-7h12v7"/>
        <path d="M10 22v-3h4v3"/>
      </svg>
      <!-- Customer-material — kotak dengan handshake/orang (titip stok), beda dari Production Stock -->
      <svg v-else-if="icon === 'customer-stock'" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24" class="w-5 h-5">
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
        <path d="M3.27 6.96L12 12.01l8.73-5.05"/>
        <path d="M12 22.08V12"/>
        <circle cx="12" cy="15" r="1.4"/>
      </svg>
      <!-- Sliders / Config -->
      <svg v-else-if="icon === 'sliders'" fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"/>
      </svg>
      <!-- Alert / Issue -->
      <svg v-else-if="icon === 'alert'" fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
      </svg>
      <!-- Users -->
      <svg v-else-if="icon === 'users'" fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m6-1.13a4 4 0 100-8 4 4 0 000 8zm6 0a4 4 0 10-3-6.917"/>
      </svg>
      <!-- Shield / Roles -->
      <svg v-else-if="icon === 'shield'" fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
      </svg>
      <!-- Bell / Notifications -->
      <svg v-else-if="icon === 'bell'" fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/>
      </svg>
      <!-- Chat / WhatsApp -->
      <svg v-else-if="icon === 'chat'" fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.86 9.86 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/>
      </svg>
      <!-- Mail / Email -->
      <svg v-else-if="icon === 'mail'" fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
      </svg>
    </span>

    <span v-if="!collapsed" class="text-xs leading-none whitespace-nowrap overflow-hidden">{{ label }}</span>
  </NuxtLink>
</template>

<script setup lang="ts">
const props = defineProps<{ to: string; icon: string; label: string }>()
const route = useRoute()
const collapsed = inject('sidebarCollapsed', ref(false))
const expandSidebar = inject('expandSidebar', () => {})

const target = computed(() => {
  const [path, qs = ''] = props.to.split('?')
  const query: Record<string, string> = {}
  if (qs) {
    for (const pair of qs.split('&')) {
      const [k, v = ''] = pair.split('=')
      query[decodeURIComponent(k)] = decodeURIComponent(v)
    }
  }
  return { path, query }
})

const isActive = computed(() => {
  const { path, query } = target.value
  const queryKeys = Object.keys(query)
  // Path must match exactly (or be a child) AND every query param in `to` must match route.query.
  const pathMatch = route.path === path || (path !== '/' && route.path.startsWith(path + '/'))
  if (!pathMatch && route.path !== path) return false
  if (!queryKeys.length) {
    // When `to` has no query, be strict: don't match if route still has a monitoring-style `type` query
    // (prevents "plain" link from lighting up while a ?type= variant is active).
    return route.path === path && !route.query.type
  }
  return queryKeys.every(k => String(route.query[k] ?? '') === query[k])
})

function handleClick(e: MouseEvent) {
  if (collapsed.value) {
    e.preventDefault()
    expandSidebar()
  }
}
</script>
